import { put, post, get, del } from 'lib/API';
import { AttributeImportResponse, AttributeValueRequest, MergeRequest, ReorderRequest } from 'data/Attribute';

// ===== V1 API: Vendor-Scoped (Legacy) =====

export const createAttributes = async (
  [attributes, vendorId]: any,
  { token }: any
): Promise<any[]> => {
  return Promise.allSettled(
    attributes.map((attribute: {name: string, isSelectable: boolean}) => {
      return create(attribute.name, vendorId, token!, undefined, attribute.isSelectable);
    })
  );
};

export const create = (attributeName: string, vendorId: number, token: string, productId?: number, isSelectable?: boolean): Promise<any> => {
  return post('v1/attributes', token, {
    name: attributeName,
    vendorId,
    productId,
    isSelectable
  });
};

export const addAttributeValue = async (token: string, attributeValue: any): Promise<AttributeValueRequest> => {
  return await post('v1/attributeValue', token, attributeValue);
};

export const addAttributeValues = async (token: string, attributeValues: any): Promise<AttributeImportResponse> => {
  return await post('v1/attributeValue/attributeValues', token, attributeValues);
};

export const mergeRequest = async (token: string, mergeReq: MergeRequest, param: string): Promise<any> => {
  return await post(`v1/${param}/merge`, token, mergeReq);
};

export const reorderRequest = async (token: string, mergeReq: ReorderRequest): Promise<any> => {
  return await put('v1/attributes', token, mergeReq);
};

export const updateAttributeValue = async (token: string, value: AttributeValueRequest): Promise<any> => {
  return await put(`v1/attributeValue/${value.id}`, token, value);
};

// ===== V2 API: Business-Unit-Scoped =====

/**
 * Get all attributes for a specific business unit
 */
export const getAttributesPerBusinessUnit = async (
  businessUnitId: number,
  token: string
): Promise<any> => {
  return await get('v2/attributes', token, { businessUnitId });
};

/**
 * Create a new attribute for a business unit
 * Follows v1 pattern: includes productId and isSelectable
 */
export const createAttributeForBusinessUnit = async (
  attributeName: string,
  businessUnitId: number,
  token: string,
  productId?: number,
  isSelectable?: boolean,
  featureGroupId?: number
): Promise<any> => {
  return await post('v2/attributes', token, {
    name: attributeName,
    businessUnitId,
    productId,
    isSelectable,
    featureGroupId
  });
};

/**
 * Bulk create attributes for a business unit
 */
export const createAttributesForBusinessUnitBulk = async (
  attributeNames: string[],
  businessUnitId: number,
  token: string
): Promise<any> => {
  return await post('v2/attributes/bulk', token, {
    businessUnitId,
    attributes: attributeNames.map(name => ({ name }))
  });
};

